import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { Stack } from '@mui/material';

const ConfirmDeleteDialog = ({ onClose, onDelete, item, type }) => {
    const handleDelete = e => {
        e.preventDefault();
        onDelete(item.id);
        onClose();
    };

    const dialogTitle = type === 'email'
        ? item.status === 'Scheduled'
            ? 'Cancel & Delete Campaign'
            : 'Delete Email'
        : type === 'survey'
            ? 'Delete Survey'
            : 'Delete Page';

    const dialogWarningNote = 'This is an email that has already been sent and has a campaign report and therefore deleting the email will also delete the report.';

    const dialogText = type === 'email'
        ? item.status === 'Scheduled'
            ? 'Please confirm you wish to cancel the scheduled send for this campaign and also delete the campaign itself.'
            : 'Please confirm you wish to delete this email.'
        : type === 'survey'
            ? 'Please confirm you wish to delete this survey'
            : 'Please confirm you wish to delete this page.' ;

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>{dialogTitle}: {item.name}</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Alert severity="warning">
                    This action cannot be undone.
                    </Alert>
                    {
                        item.status === 'Sent' && (
                            <Alert severity="info">
                                {dialogWarningNote}
                            </Alert>
                        )
                    }
                    <DialogContentText>
                        {dialogText}
                    </DialogContentText>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDelete}>Confirm</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
